"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BareFormSubmitButton = exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _chunk216b = require("./chunk-216b6235.js");

var _CButton = _interopRequireDefault(require("./CButton.js"));

require("./chunk-e192c2e5.js");

require("./chunk-76875e58.js");

require("./chunk-cb015231.js");

require("./chunk-8219403d.js");

require("./chunk-eb19ede6.js");

require("classnames");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-f2932d1d.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BareFormSubmitButton = function BareFormSubmitButton(_ref) {
  var dirty = _ref.formik.dirty,
      disabledUntilDirty = _ref.disabledUntilDirty,
      isDisabled = _ref.isDisabled,
      alignSelf = _ref.alignSelf,
      buttonProps = (0, _chunkB2edacfb.j)(_ref, ["formik", "disabledUntilDirty", "isDisabled", "alignSelf"]);
  return _react.default.createElement(_CButton.default, (0, _chunkB2edacfb.g)({
    alignSelf: alignSelf,
    isDisabled: isDisabled || disabledUntilDirty && !dirty,
    htmlType: "submit"
  }, buttonProps));
};

exports.BareFormSubmitButton = BareFormSubmitButton;
BareFormSubmitButton.displayName = "CForm.SubmitButton";
BareFormSubmitButton.propTypes = {
  disabledUntilDirty: _propTypes.default.bool,
  alignSelf: _propTypes.default.string
};
BareFormSubmitButton.defaultProps = {
  disabledUntilDirty: true,
  alignSelf: "flex-end"
};
var FormSubmitButton = (0, _chunk216b.b)(BareFormSubmitButton);
FormSubmitButton.displayName = BareFormSubmitButton.displayName;
FormSubmitButton.propTypes = BareFormSubmitButton.propTypes;
FormSubmitButton.defaultProps = BareFormSubmitButton.defaultProps;
BareFormSubmitButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CForm.SubmitButton",
  "props": {
    "disabledUntilDirty": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "alignSelf": {
      "defaultValue": {
        "value": "\"flex-end\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = FormSubmitButton;
exports.default = _default;
BareFormSubmitButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CForm.SubmitButton",
  "props": {
    "disabledUntilDirty": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "alignSelf": {
      "defaultValue": {
        "value": "\"flex-end\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};